 
 
 export let text = `Contamos con diferentes divisiones para atender a nuestros clientes:`;


  export let textProyect = `Kgori Punku Consultora SRL nace en octubre de 2016 con el objetivo de brindar servicios de asesoría, siempre con la política de cero accidentes, haciendo cumplir las normas vigentes de Seguridad e Higiene en el trabajo en los diversos proyectos. 

   La empresa posee profesionales y personal de apoyo que ponen a disposición su amplia experiencia en proyectos, desde el monitoreo constante de la seguridad tanto dentro de la empresa como en obra, la capacitación, el registro de visitas, junto con la preparación y respuesta ante emergencias son los pilares de la prevención y minimización de pérdidas.
   
   Nuestros profesionales en Higiene y Seguridad conocen el sistemas de gestión en EHS (bajo normas ISO 14001 y OHSAS 18001), se encuentran actualizados en las normas de gestión y se han desempeñado en distintas empresas y obras de envergadura realizando este tipo de tareas.`



  export let textConfianza = `En la tendencia mundial de protección del medio ambiente, trabajamos siguiendo protocolos de excelencia al respecto.
  `
